import Switch from './src/switch';

export default Switch;



// WEBPACK FOOTER //
// ./packages/switch/index.js